import React, {Component} from 'react';
import {team} from '../../data/team';
import Button from '../common/Button';
import {TeamWrapper, TeamProfiles} from './styles-team';
import TeamSingle from './TeamSingle';

class Team extends Component {
	render() {
		return (
			<TeamWrapper id="team">
				<div className="container">
					<h1 className="light">Project Team</h1>
					<TeamProfiles>
						{team.map((profile, index) => (
							<TeamSingle profile={profile} key={index} />
						))}
					</TeamProfiles>
				</div>
				<div className="center">
					<Button text="Our impact story" anchor="/impact" />
				</div>
			</TeamWrapper>
		);
	}
}

export default Team;
